import type { Question } from "../data"
import s01 from "./s01-the-drivers-license.json"
import s02 from "./s02-state-provincial-territory-laws-and-rules-of-the-road.json"
import s03 from "./s03-be-in-shape-to-drive.json"
import s04 from "./s04-before-you-drive.json"
import s05 from "./s05-basic-driving.json"
import s06 from "./s06-rules-of-the-road.json"
import s07 from "./s07-safe-driving-tips.json"
import s08 from "./s08-avoiding-collisions-and-emergency-situations.json"
import s09 from "./s09-sharing-the-road.json"
import s10 from "./s10-special-driving-situations.json"
import { validateQuestions } from "./validate"

function compareQuestions(a: Question, b: Question): number {
  if (a.answer.section !== b.answer.section) return a.answer.section - b.answer.section
  if (a.answer.page !== b.answer.page) return a.answer.page - b.answer.page
  return a.id.localeCompare(b.id, undefined, { numeric: true })
}

export const QUESTIONS: Question[] = validateQuestions([
  ...s01,
  ...s02,
  ...s03,
  ...s04,
  ...s05,
  ...s06,
  ...s07,
  ...s08,
  ...s09,
  ...s10,
]).sort(compareQuestions)
